import * as feedbackTypes from '../types/feedbackTypes'

const initialState = {
  allData: null,
  vendorId: '',
  mobile: '',
  feedback: {},
  mode: '',
}

const feedbackReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case feedbackTypes.CREATE_FEEDBACK:
      return {
        ...state,
        allData: payload,
      }
    case feedbackTypes.GET_ALL_FEEDBACKS:
      return {
        ...state,
        allData: payload,
      }
    case feedbackTypes.GET_FEEDBACK_QUESTIONS:
      return {
        ...state,
        allData: payload,
      }
    case feedbackTypes.GET_WORD_CHART:
      return {
        ...state,
        allData: payload,
      }
    case feedbackTypes.GET_NPS_SCORE:
      return {
        ...state,
        allData: payload,
      }
    default:
      return state
  }
}

export default feedbackReducer
